import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import AddPolicyModal from 'modules/timeoff/components/TimeoffPolicies/Add'

const AddPolicyModalPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.settings.timeoffPolicies.fullPath())
  }

  const onSuccess = (id: number) => {
    navigate(navigation.settings.timeoffPolicies.id.fullPath({ id }))
  }

  return <AddPolicyModal onClose={onClose} onSuccess={onSuccess} />
}

export default AddPolicyModalPage
